import React from 'react'
import styled from 'styled-components'
import { LargeText, Container } from '../styles/texts'
import balancer from '../assets/trusted/Balancer.svg'
import paraswap from '../assets/trusted/Paraswap.svg'
import tw from '../assets/trusted/Trustwallet.svg'
import thegraph from '../assets/trusted/thegraph.svg'
import inch from '../assets/trusted/1inch.svg'
import descentraland from '../assets/trusted/Descentraland.svg'
import trezor from '../assets/trusted/Trezor.svg'
import exodus from '../assets/trusted/Exodus.svg'
import rainbow from '../assets/trusted/Rainbow.svg'
import beethoven from '../assets/trusted/Beethoven.svg'
import ledger from '../assets/trusted/Ledger.svg'
import walletConnect from '../assets/trusted/WalletConnect.svg'

const TrustedBy = () => (
  <TrustedBySection>
    <Container>
      <Box>
        <LargeText>Trusted by</LargeText>
        <div>
          <img alt="Trustwallet" src={tw} />
          <img alt="1inch" src={inch} />
          <img alt="Paraswap" src={paraswap} />
          <img alt="Balancer" src={balancer} />
          <img alt="Rainbow" className="beet" src={rainbow} />
          <img alt="Ledger"  src={ledger} />

        </div>
        <div>
          <img alt="Trezor" src={trezor} />
          <img alt="Descentraland" src={descentraland} />
          <img alt="The graph" src={thegraph} />
          <img alt="Exodus" src={exodus} />
          <img alt="Beethoven" className="beet" src={beethoven} />
          <img alt="WalletConnect"  src={walletConnect} />
        </div>

      </Box>
    </Container>
  </TrustedBySection>
)

const TrustedBySection = styled.section`
  background: transparent;
  height: auto;
  @media only screen and (max-width: 700px) {
    padding: 0;
  }

  div {
    margin: 0
  }
`

const Box = styled.div`
  max-width: 1120px;
  margin: auto;
  padding: 70px 0 70px 0;
  @media only screen and (max-width: 700px) {
    padding: 20px 0 20px 0;
  }
  text-align: center;
  p {
    color: #a5a1b7;
  }
  img {
    height: 73px;
    &.beet {
      width: 146px;
    }
    @media only screen and (max-width: 700px) {
      height: 50px;
      &.beet {
        width: 100px;
      }
    }
  }
  div {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 15px;
    @media only screen and (max-width: 800px) {
      justify-content: center;
    }
  }
`

export default TrustedBy
